import { createEventCreator as event } from './ga';
import { LINK_SELECTED } from 'config/constants/gaCommonActions';

export const liveChatButtonSelected = event((available: boolean) => ({
  category: 'Chat Online Now Button',
  action: available ? 'Available Button Selected' : 'Unavailable Button Selected',
}));

export const liveChatNotificationPermissionGranted = event(() => ({
  category: 'Chat Online Now Button',
  action: 'Allow Notifications Permission Granted',
}));

export const liveChatNotificationPermissionDenied = event(() => ({
  category: 'Chat Online Now Button',
  action: 'Allow Notifications Permission Denied',
}));

export const conditionsApplyLinkSelected = event(() => ({
  category: 'Terms and Conditions Link',
  action: LINK_SELECTED,
}));

export const contactUsLinkSelected = event(() => ({
  category: 'Contact Us Link',
  action: LINK_SELECTED,
}));

export const completeFaqLinkSelected = event(() => ({
  category: 'Complete FAQ Link',
  action: LINK_SELECTED,
}));

export const cancellationPolicyPopUpLinkSelected = event(() => ({
  category: 'Cancellation Policy Pop Up',
  action: LINK_SELECTED,
}));

export const cancellationPolicyPopUpCloseButtonSelected = event(() => ({
  category: 'Cancellation Policy Pop Up',
  action: 'Close Button Selected',
}));

export const bookAgainLink = event(() => ({
  category: 'Book Again Link',
  action: LINK_SELECTED,
}));

export const printItineraryLink = event(() => ({
  category: 'Print Itinerary Link',
  action: LINK_SELECTED,
}));

export const modalCloseButton = event(() => ({
  category: 'Problem Pop Up',
  action: 'Close Button Selected',
}));

export const expiredCreditCardModalOpened = event(() => ({
  category: 'Expired Credit Card Modal',
  action: `Modal Opened - Contact us`,
}));

export const expiredCreditCardModalClosed = event((actionButtonClicked: boolean) => ({
  category: 'Expired Credit Card Modal',
  action: `Modal Closed - Contact us${actionButtonClicked ? ' (Button Clicked)' : ''}`,
}));

export const expiredCreditCardModalLinkSelected = event(
  (type: 'live chat' | 'email' | 'call customer support' | 'call international customer support') => ({
    category: 'Expired Credit Card Modal',
    action: `${LINK_SELECTED} - ${type}`,
  }),
);

export const invoiceDownloadFailedModalOpened = event(() => ({
  category: 'Invoice Download Failed Modal',
  action: `Modal Opened`,
}));

export const appleWalletPassDownloadFailedModalOpened = event(() => ({
  category: 'Apple Wallet Pass Download Failed Modal',
  action: `Modal Opened`,
}));

export const invoiceDownloadFailedModalClosed = event((actionButtonClicked: boolean) => ({
  category: 'Invoice Download Failed Modal',
  action: `Modal Closed${actionButtonClicked ? ' - (Button Clicked)' : ''}`,
}));

export const appleWalletPassDownloadFailedModalClosed = event((actionButtonClicked: boolean) => ({
  category: 'Apple Wallet Pass Download Failed Modal',
  action: `Modal Closed${actionButtonClicked ? ' - (Button Clicked)' : ''}`,
}));

export const invoiceDownloadFailedModalLinkSelected = event(
  (type: 'live chat' | 'email' | 'call customer support' | 'call international customer support') => ({
    category: 'Invoice Download Failed Modal',
    action: `${LINK_SELECTED} - ${type}`,
  }),
);

export const manageBookingReturnLink = event(() => ({
  category: 'Manage Booking Return Link',
  action: 'Link Selected',
}));

export const scheduledPaymentUpdateCreditCardLinkSelected = event(() => ({
  category: 'Scheduled Payment',
  action: `Update Credit Card ${LINK_SELECTED}`,
}));

export const manageQantasInPathFlightBookingLinkSelected = event(() => ({
  category: 'Qantas In Path',
  action: `Manage Flight Booking ${LINK_SELECTED}`,
}));
